(function () {
  function update() {
    var currency = window.Shopify && window.Shopify.currency;
    if (!currency) return;
    var rate = (currency.active === 'EUR' || currency.active === 'USD') ? 1 : Number(currency.rate);
    if (!Number.isFinite(rate) || rate <= 0) return;
    var display = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: currency.active, currencyDisplay: 'code'
    }).format(Math.ceil(8000 * rate) / 100);
    document.querySelectorAll('.iuh-shipping-threshold').forEach(function (el) {
      el.textContent = (currency.active === 'EUR' || currency.active === 'USD') ? display : '≈ ' + display;
      el.title = currency.active === 'USD' ? 'Free shipping from US$80.' : '€80 minimum; currency conversion is finalized at checkout.';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  document.addEventListener('shopify:section:load', update);
})();
